import React, { useRef,useEffect } from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.css';

import 'swiper/css';
import 'swiper/css/pagination';
import 'react-datepicker/dist/react-datepicker.css';
import Header from '../components/header';
import BannerTourDetail from '../components/bannerTourDetail';
import { useTranslation } from 'react-i18next';
import Personalizeyourtour from '../components/personalizeyourtour';
import Localhotels from '../components/localhotelsection';
import Footer from '../components/footer';
import Comment from '../components/comment';
import TourDetailSection from '../components/tourDetailSection';
import TourDetailManipulateSwiper from '../components/tourDetailManipulateSwiper';
import LocationOptionsSection from '../components/locationOptionsSection';
import { useSelector, useDispatch } from 'react-redux'
import { getTourDetailApi } from './api/tourdetail/tourdetailSlice';
import { useParams } from 'react-router-dom';
import LoadingPage from './loadingPage';
import FeaturedCard from './featuredcard';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Grid } from 'swiper/modules';
import 'swiper/css/grid';
import { Navigation } from 'swiper/modules';
import 'swiper/css/navigation';



function Tourdetail() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {slug} = useParams();
    const response = useSelector(state => state.tourDetailApi.tourDetailApi.data);
    
    const isLoading = useSelector(state => state.tourDetailApi.isLoading);
    useEffect(()=>{
        dispatch(getTourDetailApi(slug))
      
     },[dispatch]);
    const targetRef = useRef(null);

    const breakpoints = {
      0: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1150: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    };
    const handleScrollToTarget = () => {
      if (targetRef.current) {
        targetRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start' 
        });
      }
    };
    if(!isLoading){
      document.title =`${(response.data.featured_title)} | Cappadocia Visitor`
    } 
    if(isLoading) {
      return (<LoadingPage/>);
    };
    return (
        <div className="container-fluid w-100 h-100 p-0">
            <Header/>
            <BannerTourDetail onTargetRef={()=> handleScrollToTarget()} propsData={response.data}/>
            <TourDetailSection props={response.data}/>
            <TourDetailManipulateSwiper props={response.data}/>
            <LocationOptionsSection props={response.data} /> 
            <div className='baslik1 mediaQueryPadding text-white bgblue py-2' style={{ padding: "80px 100px 80px 100px" }} ref={targetRef}>{t('tourDetail.personalize')}</div>
            <Personalizeyourtour props={response.data}/>
            
            {response.infos.related && response.infos.related.length > 1 && (
              <>
              <div className='baslik1 mediaQueryPadding text-white bgblue py-2' style={{ padding: "80px 100px 80px 100px" }}>{t('tourDetail.similarTours')}</div>
            <div className='mediaQueryPadding col-md-12' style={{ padding: "80px 100px 80px 100px" }}>
                    <Swiper
                  slidesPerView={4}
                  spaceBetween={0}
                  breakpoints={breakpoints}
                  className="featuredswiper"
                  pagination={true}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  preventClicksPropagation={false}
                  preventClicks={false}
                  touchStartPreventDefault={false}
                  onClick={(swiper, event) => {
                    // Swiper'ın tıklama olayını engellememesi için
                    event.stopPropagation();
                  }}
                >
                              {response.infos.related.map((card,index) => (
                                  <SwiperSlide key={index}>
                                    <FeaturedCard 
                                      title={card.title} 
                                      content={card.content} 
                                      price={card.price} 
                                      saleprice={card.total_price} 
                                      star={card.star} 
                                      image={card.featured_file}
                                      slug={card.slug}
                                      tourId={card.id}
                                      isFavorited={card.favorited}
                                      perType={card.per_type.per_text}
                                      type="feature"
                                      />
                                  </SwiperSlide>
                                    ))}
                              </Swiper>
            </div>
              </>
                
            )}

            {/* <BecomeMember/> */}
            {/* <div className='mediaQueryPadding' style={{ padding: "80px 100px 80px 100px" }}>
            <Localhotels />
            </div> */}
            <Comment/>
            <Footer/>
        </div>
    );
}

export default Tourdetail;
